import {TabState, TabStateDefaults} from 'Navigation';

export default class FileTabState extends TabState {
  defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'File',
      closeable: false,
      preferenceKey: 'file',
    };
  }
}
